"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.provisionGradle = void 0;
const fs = __importStar(require("fs"));
const os = __importStar(require("os"));
const path = __importStar(require("path"));
const httpm = __importStar(require("@actions/http-client"));
const core = __importStar(require("@actions/core"));
const cache = __importStar(require("@actions/cache"));
const toolCache = __importStar(require("@actions/tool-cache"));
const gradlew = __importStar(require("./gradlew"));
const params = __importStar(require("./input-params"));
const layout = __importStar(require("./repository-layout"));
const cache_utils_1 = require("./cache-utils");
const gradleVersionsBaseUrl = 'https://services.gradle.org/versions';
function provisionGradle() {
    return __awaiter(this, void 0, void 0, function* () {
        const gradleVersion = params.getGradleVersion();
        if (gradleVersion !== '' && gradleVersion !== 'wrapper') {
            return addToPath(path.resolve(yield installGradle(gradleVersion)));
        }
        const gradleExecutable = params.getGradleExecutable();
        if (gradleExecutable !== '') {
            const workspaceDirectory = layout.workspaceDirectory();
            return addToPath(path.resolve(workspaceDirectory, gradleExecutable));
        }
        return undefined;
    });
}
exports.provisionGradle = provisionGradle;
function addToPath(executable) {
    return __awaiter(this, void 0, void 0, function* () {
        core.addPath(path.dirname(executable));
        return executable;
    });
}
function installGradle(version) {
    return __awaiter(this, void 0, void 0, function* () {
        const versionInfo = yield resolveGradleVersion(version);
        core.setOutput('gradle-version', versionInfo.version);
        return installGradleVersion(versionInfo);
    });
}
function resolveGradleVersion(version) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (version) {
            case 'current':
                return gradleCurrent();
            case 'rc':
                core.warning(`Specifying gradle-version 'rc' has been deprecated. Use 'release-candidate' instead.`);
                return gradleReleaseCandidate();
            case 'release-candidate':
                return gradleReleaseCandidate();
            case 'nightly':
                return gradleNightly();
            case 'release-nightly':
                return gradleReleaseNightly();
            default:
                return gradle(version);
        }
    });
}
function gradleCurrent() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield gradleVersionDeclaration(`${gradleVersionsBaseUrl}/current`);
    });
}
function gradleReleaseCandidate() {
    return __awaiter(this, void 0, void 0, function* () {
        const versionInfo = yield gradleVersionDeclaration(`${gradleVersionsBaseUrl}/release-candidate`);
        if (versionInfo && versionInfo.version && versionInfo.downloadUrl) {
            return versionInfo;
        }
        core.info('No current release-candidate found, will fallback to current');
        return gradleCurrent();
    });
}
function gradleNightly() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield gradleVersionDeclaration(`${gradleVersionsBaseUrl}/nightly`);
    });
}
function gradleReleaseNightly() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield gradleVersionDeclaration(`${gradleVersionsBaseUrl}/release-nightly`);
    });
}
function gradle(version) {
    return __awaiter(this, void 0, void 0, function* () {
        const versionInfo = yield findGradleVersionDeclaration(version);
        if (!versionInfo) {
            throw new Error(`Gradle version ${version} does not exists`);
        }
        return versionInfo;
    });
}
function gradleVersionDeclaration(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield httpGetGradleVersion(url);
    });
}
function findGradleVersionDeclaration(version) {
    return __awaiter(this, void 0, void 0, function* () {
        const gradleVersions = yield httpGetGradleVersions(`${gradleVersionsBaseUrl}/all`);
        return gradleVersions.find((entry) => {
            return entry.version === version;
        });
    });
}
function installGradleVersion(versionInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        return core.group(`Provision Gradle ${versionInfo.version}`, () => __awaiter(this, void 0, void 0, function* () {
            return locateGradleAndDownloadIfRequired(versionInfo);
        }));
    });
}
function locateGradleAndDownloadIfRequired(versionInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        const installsDir = path.join(os.homedir(), 'gradle-installations/installs');
        const installDir = path.join(installsDir, `gradle-${versionInfo.version}`);
        if (fs.existsSync(installDir)) {
            core.info(`Gradle installation already exists at ${installDir}`);
            return executableFrom(installDir);
        }
        const downloadPath = yield downloadAndCacheGradleDistribution(versionInfo);
        yield toolCache.extractZip(downloadPath, installsDir);
        core.info(`Extracted Gradle ${versionInfo.version} to ${installDir}`);
        const executable = executableFrom(installDir);
        fs.chmodSync(executable, '755');
        core.info(`Provisioned Gradle executable ${executable}`);
        return executable;
    });
}
function downloadAndCacheGradleDistribution(versionInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        const downloadPath = path.join(os.homedir(), `gradle-installations/downloads/gradle-${versionInfo.version}-bin.zip`);
        if ((0, cache_utils_1.isCacheDisabled)()) {
            yield downloadGradleDistribution(versionInfo, downloadPath);
            return downloadPath;
        }
        const cacheKey = `gradle-${versionInfo.version}`;
        try {
            const restoreKey = yield cache.restoreCache([downloadPath], cacheKey);
            if (restoreKey) {
                core.info(`Restored Gradle distribution ${cacheKey} from cache to ${downloadPath}`);
                return downloadPath;
            }
        }
        catch (error) {
            (0, cache_utils_1.handleCacheFailure)(error, `Restore Gradle distribution ${versionInfo.version} failed`);
        }
        core.info(`Gradle distribution ${versionInfo.version} not found in cache. Will download.`);
        yield downloadGradleDistribution(versionInfo, downloadPath);
        if (!(0, cache_utils_1.isCacheReadOnly)()) {
            try {
                yield cache.saveCache([downloadPath], cacheKey);
            }
            catch (error) {
                (0, cache_utils_1.handleCacheFailure)(error, `Save Gradle distribution ${versionInfo.version} failed`);
            }
        }
        return downloadPath;
    });
}
function downloadGradleDistribution(versionInfo, downloadPath) {
    return __awaiter(this, void 0, void 0, function* () {
        yield toolCache.downloadTool(versionInfo.downloadUrl, downloadPath);
        core.info(`Downloaded ${versionInfo.downloadUrl} to ${downloadPath} (size ${fs.statSync(downloadPath).size})`);
    });
}
function executableFrom(installDir) {
    return path.join(installDir, 'bin', `${gradlew.installScriptFilename()}`);
}
function httpGetGradleVersion(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return JSON.parse(yield httpGetString(url));
    });
}
function httpGetGradleVersions(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return JSON.parse(yield httpGetString(url));
    });
}
function httpGetString(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const httpClient = new httpm.HttpClient('gradle/gradle-build-action');
        const response = yield httpClient.get(url);
        return response.readBody();
    });
}
